import { SET_LOAD_POSITIONS, CLEAR_LOAD_POSITIONS } from '../actionTypes'
// import moment from 'moment'
// import _ from 'lodash'

const initialState = []

export default (state=initialState,  payload) => {
    switch(payload.type) {

    case SET_LOAD_POSITIONS:
        return payload.positions || null
    case CLEAR_LOAD_POSITIONS:
        return initialState
    default:
        return state
    }
}